'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Yandex API config
 */
var apiConfig = exports.apiConfig = {
  host: 'api-maps.yandex.ru',
  version: '2.1'
};


//////////////////
// WEBPACK FOOTER
// ./~/yandex-map-react/lib/configs/index.js
// module id = 487
// module chunks = 0